<template>
  <v-card height="100%">
    <v-card-title>Webhook</v-card-title>
    <v-card-subtitle>
      To receive events from FPT AI
    </v-card-subtitle>
    <v-card-text class="d-flex">
      <div>
        <p class="v-label font-weight-bold">Callback URL</p>
        <p>{{currentApp['webhook_url']}}</p>
      </div>
      <v-spacer/>
      <div>
        <p class="v-label font-weight-bold">Verification code</p>
        <p>{{`${currentApp['webhook_url'] ? '•••••••••••••••••••' : ''}`}}</p>
      </div>
      <v-spacer/>
      <v-btn class="text-none" color="primary" depressed @click="showWebhookEditor=true">Update</v-btn>
    </v-card-text>
    <v-divider/>
    <v-card-title>
      Events
      <v-spacer/>
      <v-btn v-if="permissionEditEvent" class="text-none" color="primary" @click="showEventForm = true">Add event</v-btn>
    </v-card-title>
    <v-card-subtitle>
      List of events sent via webhook
    </v-card-subtitle>
    <v-card-text>
      <v-simple-table>
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-left">
              No.
            </th>
            <th class="text-left">
              Event Name
            </th>
            <th class="text-center">
              Action
            </th>
            <th class="text-center">
              Example
            </th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="(item, idx) in shadowAppEvents"
              :key="idx"
          >
            <td>
              {{idx + 1}}
            </td>
            <td class="text-left">
              {{item.title}}
            </td>
            <td class="text-center" style="display: flex; align-items: center; justify-content: center">
              <v-switch
                  @change="changeEventStatus(item)"
                  inset
                  flat
                  v-model="item.status"
              ></v-switch>
              <v-btn icon color="primary" v-if="permissionEditEvent" @click="editItem(item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon color="red" v-if="permissionEditEvent" @click="remove(item.id)">
                <v-icon>mdi-trash-can-outline</v-icon>
              </v-btn>
            </td>
            <td class="text-center">
              <v-btn color="primary" class="text-none" @click="viewExampleEvent(item)">Example</v-btn>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import {get, sync} from "vuex-pathify";
import {mapActions} from "vuex";
import _ from "lodash"
import {EventConfigService} from "@/services";
import AppService from "@/services/app.service";

export default {
  name: "ApplicationWebhook",
  data() {
    return {
      shadowAppEvents: [],
    }
  },
  mounted() {
    this.findAll()
  },
  computed: {
    showWebhookEditor: sync('dialogs/showWebhookEditor'),
    showEventExampleViewer: sync('dialogs/showEventExampleViewer'),
    currentApp: sync('application/currentApp'),
    showEventForm: sync('dialogs/showEventForm'),
    profile: sync('user/profile'),
    events: get('event/items'),
    currentEvent: sync('event/currentItem'),
    permissionEditEvent() {
      return this.profile.role === "admin"
    }
  },
  watch: {
    currentApp: {
      deep: true,
      immediate: true,
      handler() {
        this.syncShadowAppEvents()
      }
    },
    events: {
      immediate: true,
      handler() {
        this.syncShadowAppEvents()
      }
    }
  },
  methods: {
    ...mapActions('event', ['findAll', 'remove']),
    editItem(item) {
      this.currentEvent = item
      this.showEventForm = true
    },
    viewExampleEvent(item) {
      this.currentEvent = item;
      this.showEventExampleViewer = true
    },
    changeEventStatus(item) {
      if (item.status) {
        EventConfigService.create({
          app_id: this.currentApp.id,
          event_id: item.id
        })
        .then((res)=> {
          this.currentApp.events = [...this.currentApp.events, res.data]
          this.syncShadowAppEvents()
          AppService.toastSuccess("Update event successfully")
        })
        .catch(() => {
          item.status = !item.status
          AppService.toastError("Update event failed")
        })
      }
      else {
        EventConfigService.remove(item.event_config_id)
        .then(()=> {
          this.currentApp.events = this.currentApp.events.filter(o => o.id !== item.event_config_id);
          this.syncShadowAppEvents()
          AppService.toastSuccess("Update event successfully")
        })
        .catch(()=> {
          item.status = !item.status
          AppService.toastError("Update event failed")
        })
      }
    },
    syncShadowAppEvents() {
      this.shadowAppEvents = [
        ...this.currentApp.events
      ]
      this.shadowAppEvents = _.map(this.shadowAppEvents, o => {
        const objReturn = {
          id: o.event.id,
          title: o.event.title,
          value: o.event.value,
          status: true,
          event_config_id: o.id,
          example: o.event.example
        }
        const eventTemp = _.find(this.events, _.matchesProperty('id', o.event.id))
        if (eventTemp) {
          objReturn.title = eventTemp.title
          objReturn.value = eventTemp.value
          objReturn.example = eventTemp.example
        }
        return objReturn
      })
      const diffEvents = _.differenceBy(this.events, this.shadowAppEvents, 'id')
      this.shadowAppEvents = [
          ...this.shadowAppEvents,
          ...diffEvents
      ]
      this.shadowAppEvents = _.sortBy(this.shadowAppEvents, ['title'])
    }
  }
}
</script>

<style scoped>

</style>
